import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { updateDateSelect } from "GeneralTabAction";
import { isEmpty } from "ActionsSpeakers";
import { updateUnsavedChanges } from "DashboardMenuAction";

class DateBlock extends Component {
  constructor(props) {
    super(props);
    this.handleDateSelect = this.handleDateSelect.bind(this);
  }

  handleDateSelect = (obj) => {
    // debugger;
    if (this.props.allDate.length >= 1) {
      this.props.updateUnsavedChanges();
    }
    this.props.updateDateSelect(this.props.allDate, this.props.day);
  };

  render() {
    var activeDateClass = this.props.activeDate
      ? "li-days days-active"
      : "li-days";
    var isDisabled = this.props.isPublished;

    return (
      <li
        className={activeDateClass}
        onClick={!isDisabled ? this.handleDateSelect : null}
        style={{ marginRight: 12 }}
      >
        <div className="date">{this.props.day.format("DD")}</div>
        <div className="day">{this.props.day.format("dd")}</div>
        {this.props.activeDate ? (
          <img
            className="day-tick"
            src="../../style/images/v2_icons/theme-tick-blue.png"
          />
        ) : null}
      </li>
    );
  }
}
function mapStateToProps(state) {
  var eventData = state.eventData[0];
  var isPublished = false;
  var today = moment().format("YYYY-MM-DD");

  if (eventData) {
    // isPublished = eventData.published;
    isPublished = moment(eventData.eventenddate).isSameOrBefore(today); // Now we are allowing admin to change event date before event end date. This code is updated by vinay on 23/08/2021
  }

  return {
    session: state.session,
    allDate: state.updateScheduleDates,
    scheduledates: state.scheduledates,
    isPublished,
  };
}
export default connect(mapStateToProps, {
  updateDateSelect,
  updateUnsavedChanges,
})(DateBlock);
